@if (formName) {
  <div class="instrument-toggler-container">
    <div class="name">
      @if (formName.value.cash) {
        {{ 'global.cash' | translate }}
      } @else {
        @if (!formName.value.cash) {
          @if (formName.value.humanName) {
            {{ formName.value.humanName }}
          } @else {
            {{ 'global.error.unnamed' | translate }}
          }
        } @else {
          {{ formName.value.name }}
        }
      }
    </div>
    @if (instrumentRemovable()) {
      <button class="toggle-button" (click)="removeSelectedInstrument()" [attr.data-cy]="'remove-picked-investment'">
        <svg-icon src="assets/icons/cross.svg" [svgStyle]="{ 'width.px':15, 'height.px':15 }"></svg-icon>
      </button>
    }
  </div>
}